import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const currencyFmt = (amount, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount || 0);

// All timestamps are displayed in New Zealand time (Pacific/Auckland).
export const NZ_TZ = "Pacific/Auckland";

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: NZ_TZ, day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    }).format(new Date(iso)).replace(/\//g, "-");
  } catch { return iso; }
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: NZ_TZ, day: "2-digit", month: "2-digit", year: "numeric",
    }).format(new Date(iso)).replace(/\//g, "-");
  } catch { return iso; }
};

// Plain calendar date (YYYY-MM-DD, no timezone) → DD-MM-YYYY.
export const fmtDateOnly = (s) => {
  if (!s) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s));
  return m ? `${m[3]}-${m[2]}-${m[1]}` : s;
};

// Current calendar date (YYYY-MM-DD) in New Zealand time.
export const nzToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: NZ_TZ }).format(new Date());

export const ROLE_LABEL = {
  super_admin: "Super Administrator",
  admin: "Administrator",
  manager: "Manager",
  branch_manager: "Branch Manager",
  employee: "Employee",
};
